import React from 'react';

const NoDataCrm = ({ rows }) => {
    return (
        <div className='d-flex justify-content-center align-items-center w-100 py-4'>
            {rows.length === 0 && <big className='text-muted'>Ingen data att visa</big>}
        </div>
    );
};

export default NoDataCrm;
